var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"card-custom",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-0"},[_c('b-embed',{staticClass:"rounded",attrs:{"type":"iframe","aspect":"16by9","src":"http://172.16.20.68:3000/d/0hyIh0-Vk/vpn-microservice?orgId=1&refresh=10s"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }